import { supabase } from "@/integrations/supabase/client";
import { v4 as uuidv4 } from 'uuid';

export function getAvatarUrl(avatar: string | null | undefined): string {
	if (!avatar) return '/default-avatar.png';
	return `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/avatars/${avatar}`;
}

export async function uploadAvatarToStorage(file: File): Promise<string | null> {
	try {
		const fileExt = file.name.split('.').pop();
		const fileName = `${uuidv4()}.${fileExt}`;
		const filePath = `avatars/${fileName}`;

		const { error } = await supabase.storage.from('avatars').upload(filePath, file);

		if (error) {
			console.error('Avatar upload error:', error.message);
			return null;
		}

		return filePath;
	} catch (err) {
		console.error('Unexpected avatar upload error:', err);
		return null;
	}
}

export async function updateUserProfile(id: string, username: string, avatarFileName: string | null) {
	const { error } = await supabase.functions.invoke(
		'update-user-profile',
		{ body: { user_id: id, username, avatar: avatarFileName } }
	);
	if (error) throw new Error(error.message);
}

interface IPubUser {
	username: string;
	avatar?: string;
	user_rating: { score: number; };
	created_at: string;
}

export async function fetchUserById(userId: string): Promise<IPubUser | null> {
	const { data, error } = await supabase
		.from('user_subscriptions')
		.select('username, avatar, created_at, user_rating: user_rating (score)')
		.eq('user_id', userId)
		.single();

	if (error) throw new Error(error.message);
	const rating = Array.isArray(data.user_rating) ? (data.user_rating[0] || { score: 0 }) : data.user_rating;
	return { ...data, user_rating: rating };
}

export async function fetchUsersCount(): Promise<number> {
  const { count, error } = await supabase
    .from('user_subscriptions')
    .select('*', { count: 'exact', head: true });

  if (error) throw new Error(error.message);

  return count ?? 0;
}